import { toast, ToastOptions } from 'react-toastify'
import { ToastId } from '../toastDispatchers/dispatchOrUpdateToast'

/*
	This file is a workaround for a bug in react-toastify:
	https://github.com/fkhadra/react-toastify/issues/594
 */
export const isToastInBuggedState = (id?: ToastId): id is ToastId => {
  return !!id && !toast.isActive(id) && isToastOpen(id)
}

const openIds = new Set<ToastId>()
export const isToastOpen = (id?: ToastId): id is ToastId => !!id && openIds.has(id)
const registerOpenToast = (id?: ToastId) => id && openIds.add(id)
const unregisterOpenToast = (id?: ToastId) => id && openIds.delete(id)

export const bindStatusListenersToOptions = (options?: ToastOptions): ToastOptions => {
  return {
    ...options,
    onClose: (params: any) => {
      unregisterOpenToast(options?.toastId)
      options?.onClose?.(params)
    },
    onOpen: (opts: any) => {
      registerOpenToast(options?.toastId)
      options?.onOpen?.(opts)
    }
  }
}

export const waitUntilToastIsClosed = (id?: ToastId) => {
  const TIMEOUT_THRESHOLD = 3000
  const QUERY_INTERVAL = 50

  return new Promise<void>((resolve, reject) => {
    const initialTimestamp = Date.now()

    const intervalId = setInterval(() => {
      if (Date.now() - initialTimestamp > TIMEOUT_THRESHOLD) {
        clearInterval(intervalId)
        reject()
      }

      if (!isToastOpen(id)) {
        clearInterval(intervalId)
        resolve()
      }
    }, QUERY_INTERVAL)
  })
}
